'use strict';

let processInclude = require('base/util');

$(document).ready(function () {
	processInclude(require('./cart/cart'));
	processInclude(require('./components/cartPromotionToast'));
	processInclude(require('./components/cartStickyCheckout'));
	processInclude(require('./components/cartRemoveProductModal'));
});
